import { Button } from 'antd'
import { CustomFooterLayout } from '../../../../atom/price'
import { HorizontalLine } from '../../../../atom/horizontal-line'
import { FormInstance } from 'antd/es/form/Form'
import { useGeneralTranslation } from '../../../../hooks/translation/useGeneralTranslation'
import { useDiscountSchemaTranslation } from 'hooks/translation/useDiscountSchemaTranslation'
import { DiscountSchemaPayload } from 'models/discount'
import { useState, useEffect } from 'react'

interface props {
  loading: boolean
  form: FormInstance
  discountNameExists?: { [key: number]: boolean }
  promoCodeExists?: { [key: number]: boolean }
  current?: number
  modalType?: string
  setNextInModal?: (nextInModal: boolean) => void
  onCancel: () => void
  back?: () => void
  onSubmitAll?: () => void
  forms?: FormInstance[]
  multiDiscountNameExists?: any
  multiPromoCodeExists?: any
  handleSubmitAllForms?: () => Promise<void>
  formName?: string
}

export const DiscountFooterSectionModal: React.FC<props> = ({
  loading,
  form,
  discountNameExists,
  promoCodeExists,
  current,
  modalType,
  onCancel,
  setNextInModal,
  back,
  onSubmitAll,
  forms = [],
  multiDiscountNameExists,
  multiPromoCodeExists,
  handleSubmitAllForms,
  formName,
}) => {
  const { saveText, nextText } = useGeneralTranslation()
  const { skipDiscountPlanText } = useDiscountSchemaTranslation()
  const [isValid, setIsValid] = useState(true)

  // Check validation for single form case
  const hasSingleFormValidationErrors = (form: FormInstance) => {
    let exists = false
    form.getFieldsValue(true)[formName ?? 'discount_schema_form']?.map((discountSchema: DiscountSchemaPayload) => {
      if (discountSchema.name === '' || discountSchema.promo_code === '') return (exists = true)
      return exists
    })
    return (
      Object.values(multiDiscountNameExists ? multiDiscountNameExists : {}).some((state) => state === true) ||
      Object.values(multiPromoCodeExists ? multiPromoCodeExists : {}).some((state) => state === true) ||
      Object.values(discountNameExists ? discountNameExists : {}).some((state) => state === true) ||
      Object.values(promoCodeExists ? promoCodeExists : {}).some((state) => state === true) ||
      exists
    )
  }

  // Check validation for multiple forms case
  const hasMultipleFormsValidationErrors = () => {
    return forms.some((form) => hasSingleFormValidationErrors(form))
  }

  // Effect to check validation whenever forms or their values change
  useEffect(() => {
    const checkValidation = () => {
      if (forms.length > 0) {
        setIsValid(!hasMultipleFormsValidationErrors())
      } else {
        setIsValid(!hasSingleFormValidationErrors(form))
      }
    }

    // Initial validation
    checkValidation()
  }, [forms, form, discountNameExists, promoCodeExists, multiDiscountNameExists, multiPromoCodeExists])

  return (
    <>
      <HorizontalLine />
      <CustomFooterLayout>
        {current === 0 ? (
          <Button
            type="primary"
            onClick={
              setNextInModal
                ? () => {
                    setNextInModal(true)
                  }
                : () => {}
            }
          >
            {nextText}
          </Button>
        ) : (
          <>
            {modalType === 'discount-only' && (
              <Button key="back" loading={loading} onClick={back} style={{ position: 'absolute', left: '24px' }}>
                Back
              </Button>
            )}
            {modalType === 'both' && (
              <Button key="back" loading={loading} onClick={onCancel}>
                {skipDiscountPlanText}
              </Button>
            )}

            <Button
              key="submit"
              htmlType={forms.length > 0 ? undefined : 'submit'}
              type="primary"
              loading={loading}
              disabled={!isValid}
              onClick={forms.length > 0 ? handleSubmitAllForms : undefined}
            >
              {saveText}
            </Button>
          </>
        )}
      </CustomFooterLayout>
    </>
  )
}
